<template>
  <div class="content">
    <div class="container-fluid">

      <div class="row">
        <div class="col-md-4 col-12">
        </div>
        <div class="col-md-4 col-12">
          <br><br><br>
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <img src="@/assets/img/logo.png" alt="">
              <hr>
              <label for="password1">Escriba la nueva password:</label>
              <input type="password" v-model="password1" name="password1" class="form-control"/>
              <label for="password2">Repita la password:</label>
              <input type="password" v-model="password2" name="password1" class="form-control"/>
            </div>
            <p>{{ tokenValid }}</p>
            <p>
              <v-icon :color="OkColor(passwordLenght)" :name="Ok(passwordLenght)"></v-icon>
              La contraseña tiene 8 caracteres
            </p>
            <p>
              <v-icon :color="OkColor(passwordMayuscula)" :name="Ok(passwordMayuscula)"></v-icon>
              La contraseña contiene al menos una letra mayúscula
            </p>
            <p>
              <v-icon :color="OkColor(passwordMinuscula)" :name="Ok(passwordMinuscula)"></v-icon>
              La contraseña contiene al menos una letra minúscula
            </p>
            <p>
              <v-icon :color="OkColor(passwordNumero)" :name="Ok(passwordNumero)"></v-icon>
              La contraseña contiene al menos un número
            </p>
            <p>
              <v-icon :color="OkColor(bothPasswordsEqual)" :name="Ok(bothPasswordsEqual)"></v-icon>
              Ambas contraseñas coinciden
            </p>
            <div class="form-group">
              <button class="btn btn-primary" :disabled="!ValidatePassword">Cambiar la contraseña
              </button>
              <br><br>
              <p>{{ mensaje }}</p>
            </div>
          </form>
        </div>
        <div class="col-md-4 col-12">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import 'vue-awesome/icons'
import {userService} from '@/src/../_services';

export default {
  props: {
    token: String,
  },
  data() {
    return {
      password1: '',
      password2: '',
      mensaje: '',
      tokenValid: '',
      passwordLenght: false,
      passwordMayuscula: false,
      passwordMinuscula: false,
      passwordNumero: false,
      bothPasswordsEqual: false
    }
  },
  computed: {
    ValidatePassword() {
      let passwordStrength = userService.PasswordStrengthMeter(this.password1)
      return ((passwordStrength.longitud > 8) &&
        (passwordStrength.mayuscula) &&
        (passwordStrength.minuscula) &&
        (passwordStrength.numero) &&
        ((this.password1 == this.password2) && (passwordStrength.longitud > 0)))
    }
  },
  watch: {
    password1: function (value) {
      let passwordStrength = userService.PasswordStrengthMeter(value)
      this.passwordLenght = (passwordStrength.longitud > 8)
      this.passwordMinuscula = passwordStrength.minuscula
      this.passwordMayuscula = passwordStrength.mayuscula
      this.passwordNumero = passwordStrength.numero
      this.bothPasswordsEqual = ((this.password2 == value) && (value.length > 0))
    },
    password2: function (value) {
      this.bothPasswordsEqual = ((this.password1 == value) && (this.password1.length > 0))
    }
  },
  methods: {
    Ok(value) {
      if (value) {
        return "thumbs-up"
      } else return "thumbs-down"
    },
    OkColor(value) {
      if (value) {
        return "green"
      } else return "red"
    },
    async handleSubmit(e) {
      var request = await userService.changePassword(this.token, this.password)
      this.mensaje = request.respuesta
    }
  },
};
</script>

<style>
.form-control {
  background-color: #c3dfff !important;
}

.btn-primary {
  background-color: #d0212d !important;
  border-color: #d0212d !important;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}

.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #d0212d !important;
  border-color: #d0212d !important;
}

</style>
